import styled, { css } from "styled-components";
const titles = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 160px;
`;
export const Container = styled.div`
  ${({ title }) => title && titles};
  padding: 20px 100px 110.5px;
  background: #000016;
  @media (max-width: 1049px) {
    padding: 0 20px;
  }
  animation: meals-appear 1s ease-out forwards;
  @keyframes meals-appear {
    from {
      opacity: 0;
      transform: translateY(4rem);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
const Range = css`
  ::before {
    content: "";
    position: absolute;
    top: 10px;
    left: 50%;
    width: 150px;
    height: 4px;
    background: crimson;
    transform: translateX(-50%);
  }
  ::after {
    content: "";
    position: absolute;
    top: 3px;
    left: 50%;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: crimson;
    transform: translateX(-50%);
  }
  margin-bottom: 60px;
`;

const ContentTitle = css`
  font-size: 30px;
  font-weight: 800;
  margin-bottom: 20px;
  color: #fff;
  @media (max-width: 1049px) {
    text-align: center;
  }
`;
const Span = css`
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  animation: meals-appear 1s ease-out forwards;

  @keyframes meals-appear {
    from {
      transform: translateY(4rem);
    }

    to {
      transform: translateY(0);
    }
  }
`;

export const Title = styled.div`
  position: relative;
  color: crimson;
  font-size: 35px;
  font-weight: 800;
  ${({ range }) => range && Range};
  ${({ content }) => content && ContentTitle};
  ${({ span }) => span && Span};
`;

const Content = css`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #fff;
  margin-top: 20px;
  @media (max-width: 1049px) {
    flex-direction: column;
    align-items: center;
  }
`;
const ColLeft = css`
  position: relative;
  width: 45%;
  @media (max-width: 1049px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
const Column = css`
  position: relative;
  width: 100%;
`;
const ColRight = css`
  position: relative;
  width: 45%;
  @media (max-width: 1049px) {
    margin-top: 40px;
  }
`;
const Bar = css`
  margin-bottom: 15px;
  padding: 10px;
`;
const Info = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
`;
const LineHtml = css`
  position: relative;
  width: 100%;
  height: 15px;
  background-color: #cccccc;
  border-radius: 2px;
  position: relative;
  ::before {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 3px;
    animation: html 2.5s;
    animation-timing-function: infinite;
  }
`;
const Html = css`
  ::before {
    width: 95%;
    background-color: coral;
    @keyframes html {
      0% {
        width: 0%;
      }
      95% {
        width: 95%;
        background-color: coral;
      }
    }
  }
`;
const LineCss = css`
  position: relative;
  width: 100%;
  height: 15px;
  background-color: #cccccc;
  border-radius: 2px;
  position: relative;
  ::before {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 3px;
    animation: css 2.5s;
    animation-timing-function: infinite;
  }
`;
const Css = css`
  ::before {
    width: 95%;
    background-color: #318fd8;
    @keyframes css {
      0% {
        width: 0%;
      }
      95% {
        width: 95%;
        background-color: #318fd8;
      }
    }
  }
`;
const LineJs = css`
  position: relative;
  width: 100%;
  height: 15px;
  background-color: #cccccc;
  border-radius: 2px;
  position: relative;
  ::before {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 3px;
    animation: js 2.5s;
    animation-timing-function: infinite;
  }
`;
const Javascript = css`
  ::before {
    width: 80%;
    background-color: #f4de00;
    @keyframes js {
      0% {
        width: 0%;
      }
      80% {
        width: 80%;
        background-color: #f4de00;
      }
    }
  }
`;
const LineReact = css`
  position: relative;
  width: 100%;
  height: 15px;
  background-color: #cccccc;
  border-radius: 2px;
  position: relative;
  ::before {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 3px;
    animation: react 2.5s;
    animation-timing-function: infinite;
  }
`;
const React = css`
  ::before {
    width: 80%;
    background-color: #75dbfd;
    @keyframes react {
      0% {
        width: 0%;
      }
      80% {
        width: 80%;
        background-color: #75dbfd;
      }
    }
  }
`;

export const Wrapper = styled.div`
  ${({ content }) => content && Content};
  ${({ colLeft }) => colLeft && ColLeft};
  ${({ colRight }) => colRight && ColRight};
  ${({ bar }) => bar && Bar};
  ${({ info }) => info && Info};
  ${({ lineHtml }) => lineHtml && LineHtml};
  ${({ lineCss }) => lineCss && LineCss};
  ${({ lineJs }) => lineJs && LineJs};
  ${({ lineReact }) => lineReact && LineReact};
  ${({ html }) => html && Html};
  ${({ css }) => css && Css};
  ${({ javaScript }) => javaScript && Javascript};
  ${({ react }) => react && React};
  ${({ column }) => column && Column}/* background: ${({ color }) => color}; */
`;

export const Desc = styled.p`
  @media (max-width: 1049px) {
    text-align: center;
  }
`;
